import { render } from "./Enquiry.vue?vue&type=template&id=25fb8781&lang=true"
import script from "./Enquiry.vue?vue&type=script&lang=js"
export * from "./Enquiry.vue?vue&type=script&lang=js"

import "./Enquiry.vue?vue&type=style&index=0&id=25fb8781&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__